"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyAdvancedSearchData = exports.DISTANCE_OPTIONS = exports.getClosestDistanceOption = exports.convertMetersToMilesEnum = exports.convertMilesToMeters = exports.DISTANCE_IN_MILES = void 0;
exports.getFilterByDisciplinesOrder = getFilterByDisciplinesOrder;
exports.getDisciplineByDepartmentId = getDisciplineByDepartmentId;
exports.getSuggestedDiscipline = getSuggestedDiscipline;
exports.getDepartmentId = getDepartmentId;
exports.buildClinicianRoleFilters = buildClinicianRoleFilters;
exports.buildServicesToPatientFilters = buildServicesToPatientFilters;
exports.buildExistingMembersWithUserInfo = buildExistingMembersWithUserInfo;
exports.buildAdvanceSearchPayload = buildAdvanceSearchPayload;
const domain_1 = require("@home-health-notify/domain");
const config_1 = require("../i18n/config");
const MessageHelper_1 = require("./MessageHelper");
var DISTANCE_IN_MILES;
(function (DISTANCE_IN_MILES) {
    DISTANCE_IN_MILES[DISTANCE_IN_MILES["TWO"] = 2] = "TWO";
    DISTANCE_IN_MILES[DISTANCE_IN_MILES["FIVE"] = 5] = "FIVE";
    DISTANCE_IN_MILES[DISTANCE_IN_MILES["TEN"] = 10] = "TEN";
    DISTANCE_IN_MILES[DISTANCE_IN_MILES["FIFTEEN"] = 15] = "FIFTEEN";
    DISTANCE_IN_MILES[DISTANCE_IN_MILES["TWENTY"] = 20] = "TWENTY";
    DISTANCE_IN_MILES[DISTANCE_IN_MILES["TWENTY_FIVE"] = 25] = "TWENTY_FIVE";
})(DISTANCE_IN_MILES || (exports.DISTANCE_IN_MILES = DISTANCE_IN_MILES = {}));
const convertMilesToMeters = (miles) => {
    const meters = miles * 1609.34;
    return Math.floor(meters);
};
exports.convertMilesToMeters = convertMilesToMeters;
const convertMetersToMilesEnum = (meters) => {
    const miles = (0, MessageHelper_1.getMilesFromMeters)(meters);
    return Math.floor(miles);
};
exports.convertMetersToMilesEnum = convertMetersToMilesEnum;
/**
 * Gets the closest DISTANCE_IN_MILES option for a given miles value
 * Returns the smallest option that is >= the given miles, or the largest option if miles exceeds all options
 * @param miles - The miles value to find the closest option for
 * @returns The closest DISTANCE_IN_MILES enum value
 */
const getClosestDistanceOption = (miles) => {
    const sortedOptions = [
        DISTANCE_IN_MILES.TWO,
        DISTANCE_IN_MILES.FIVE,
        DISTANCE_IN_MILES.TEN,
        DISTANCE_IN_MILES.FIFTEEN,
        DISTANCE_IN_MILES.TWENTY,
        DISTANCE_IN_MILES.TWENTY_FIVE,
    ];
    // Find the smallest option that is >= miles
    for (const option of sortedOptions) {
        if (option >= miles) {
            return option;
        }
    }
    // If miles exceeds all options, return the largest
    return DISTANCE_IN_MILES.TWENTY_FIVE;
};
exports.getClosestDistanceOption = getClosestDistanceOption;
exports.DISTANCE_OPTIONS = [
    {
        label: config_1.resources.en.advanceSearch.distanceLabels.two,
        value: DISTANCE_IN_MILES.TWO,
    },
    {
        label: config_1.resources.en.advanceSearch.distanceLabels.five,
        value: DISTANCE_IN_MILES.FIVE,
    },
    {
        label: config_1.resources.en.advanceSearch.distanceLabels.ten,
        value: DISTANCE_IN_MILES.TEN,
    },
    {
        label: config_1.resources.en.advanceSearch.distanceLabels.fifteen,
        value: DISTANCE_IN_MILES.FIFTEEN,
    },
    {
        label: config_1.resources.en.advanceSearch.distanceLabels.twenty,
        value: DISTANCE_IN_MILES.TWENTY,
    },
    {
        label: config_1.resources.en.advanceSearch.distanceLabels.twentyFive,
        value: DISTANCE_IN_MILES.TWENTY_FIVE,
    },
];
function getFilterByDisciplinesOrder(clinicianRoles, servicesToPatient, existingMembers) {
    const onlyCareEndedOrDischarged = servicesToPatient.every((service) => service.status === domain_1.SERVICE_STATUS.DISCHARGED ||
        service.status === domain_1.SERVICE_STATUS.END_OF_CARE);
    if (servicesToPatient.length > 0 && !onlyCareEndedOrDischarged) {
        const disciplineToBeSelected = getDisciplineToBeSelected(servicesToPatient, existingMembers);
        const disciplinesFilters = getDisciplinesFilters(clinicianRoles, servicesToPatient);
        return {
            disciplineToBeSelected,
            disciplinesFilters,
        };
    }
    else if (servicesToPatient.length === 0 || onlyCareEndedOrDischarged) {
        return {
            disciplineToBeSelected: clinicianRoles[0].value,
            disciplinesFilters: clinicianRoles,
        };
    }
}
function getDisciplineToBeSelected(servicesToPatient, existingMembers) {
    const onlyPendingServices = servicesToPatient.every((service) => service.status === domain_1.SERVICE_STATUS.PENDING);
    const onlyCompletedServices = servicesToPatient.every((service) => service.status === domain_1.SERVICE_STATUS.ACTIVE);
    if (onlyPendingServices) {
        return getPendingServiceToSelect(servicesToPatient, existingMembers);
    }
    else if (onlyCompletedServices) {
        return servicesToPatient[0].value;
    }
    else {
        return getServiceToSelect(servicesToPatient, existingMembers);
    }
}
function getDisciplinesFilters(clinicianRoles, servicesToPatient) {
    const remainingServices = clinicianRoles.filter((role) => !servicesToPatient.some((service) => service.value === role.value));
    remainingServices.sort((disciplineA, disciplineB) => disciplineA.value.localeCompare(disciplineB.value));
    return [...servicesToPatient, ...remainingServices];
}
function getPendingServiceToSelect(servicesToPatient, existingMembers) {
    const requiredClinicians = [];
    const existingClinicians = [];
    const clinicianMembers = existingMembers.filter((member) => member.userInfo.type === domain_1.USER_TYPE.STAFF ||
        member.userInfo.type === domain_1.USER_TYPE.USER);
    servicesToPatient.forEach((service) => {
        const clinicianFound = clinicianMembers.some((member) => {
            var _a;
            return ((_a = member.userInfo.department) === null || _a === void 0 ? void 0 : _a.shortHand) === service.value;
        });
        if (clinicianFound) {
            existingClinicians.push(service);
        }
        else {
            requiredClinicians.push(service);
        }
    });
    if (requiredClinicians.length === 0) {
        return existingClinicians[0].value;
    }
    return requiredClinicians[0].value;
}
function getServiceToSelect(servicesToPatient, existingMembers) {
    const hasDischargedOrEndOfCare = servicesToPatient.some((service) => service.status === domain_1.SERVICE_STATUS.DISCHARGED ||
        service.status === domain_1.SERVICE_STATUS.END_OF_CARE);
    const pendingServices = servicesToPatient.filter((service) => service.status === domain_1.SERVICE_STATUS.PENDING);
    const completedServices = servicesToPatient.filter((service) => service.status === domain_1.SERVICE_STATUS.ACTIVE);
    if (hasDischargedOrEndOfCare &&
        completedServices.length > 0 &&
        pendingServices.length === 0) {
        return completedServices[0].value;
    }
    else {
        return getPendingServiceToSelect(pendingServices, existingMembers);
    }
}
function getDisciplineByDepartmentId(id, departmentsData) {
    const department = departmentsData.find(department => department.id === id);
    return department ? department.shortHand : undefined;
}
function getSuggestedDiscipline(messageData, selectedOrgUser) {
    var _a;
    const departments = selectedOrgUser === null || selectedOrgUser === void 0 ? void 0 : selectedOrgUser.getDepartments();
    const suggestedCliniciansDepartments = (_a = (messageData.suggestedCliniciansDepartments &&
        messageData.suggestedCliniciansDepartments[0])) !== null && _a !== void 0 ? _a : undefined;
    return suggestedCliniciansDepartments && departments
        ? getDisciplineByDepartmentId(suggestedCliniciansDepartments, departments)
        : undefined;
}
/**
 * Get department ID from discipline shorthand
 * @param shorthand - The discipline shorthand (e.g., "SN", "PT")
 * @param departments - Array of department data
 * @returns The department ID
 */
function getDepartmentId(shorthand, departments) {
    var _a;
    const requiredDepartment = departments.find(department => department.shortHand === shorthand);
    return (_a = requiredDepartment === null || requiredDepartment === void 0 ? void 0 : requiredDepartment.id) !== null && _a !== void 0 ? _a : "";
}
/**
 * Builds clinician role filter options from departments
 * @param departments - Array of department data
 * @returns Array of clinician filter options
 */
function buildClinicianRoleFilters(departments) {
    return departments.map(department => ({
        label: department.shortHand,
        value: department.shortHand,
    }));
}
/**
 * Builds services to patient filter options
 * @param servicesToPatient - Array of services to patient
 * @returns Array of clinician filter options
 */
function buildServicesToPatientFilters(servicesToPatient) {
    return servicesToPatient.map(service => ({
        label: service.shorthand,
        value: service.shorthand,
        status: service.status,
    }));
}
/**
 * Builds existing members with user info for discipline selection logic
 * @param members - Array of group members
 * @param getUserInfo - Function to get user info by ID
 * @returns Array of members with user info
 */
function buildExistingMembersWithUserInfo(members, getUserInfo) {
    return members.map(member => (Object.assign(Object.assign({}, member), { userInfo: getUserInfo(member.userId) })));
}
/**
 * Default empty advanced search data for initial state
 */
exports.emptyAdvancedSearchData = {
    nearbyPatients: [],
    users: [],
    page: 0,
    limit: 18,
    total: 0,
    hasNext: true,
};
/**
 * Builds the advance search API payload
 * @param params - The parameters for building the payload
 * @returns The advance search payload
 */
function buildAdvanceSearchPayload(params) {
    const { advanceSearchFilters, selectedDistance, selectedDiscipline, departments, } = params;
    return Object.assign(Object.assign({}, (advanceSearchFilters.chatId && {
        groupId: advanceSearchFilters.chatId,
    })), { coordinates: [advanceSearchFilters.lng, advanceSearchFilters.lat], distance: (0, exports.convertMilesToMeters)(selectedDistance), showAddedMember: true, departments: getDepartmentId(selectedDiscipline, departments) });
}
